<div class="container">
  <div class="balance-container">
    <div class="balance crypto-balance">
      <div class="balance-header">
        <img src="/assets/icons/balance-crypto.svg" alt="crypto_icon" />
        <p class="balance-title">Crypto</p>
      </div>
      <div class="balance-info">
        <p class="equivalent-usd">
          {{ cryptoBalanceInUsd || 0 | currency : 'U$D' }}
        </p>
        <p class="balance-variance">≈ {{ cryptoBalanceInArs || 0 | currency : 'AR$' }}</p>
      </div>
      <img class="dashboard-img" src="/assets/images/dashboard-main.svg" alt="dashboard" />
    </div>

    <div class="fiat-balances">
      <div class="balance fiat-balance usd" (click)="openFiatInvestmentPopup('U$D')">
        <div class="btn-investment">
          <!-- <p [class.invested]="austProfits?.totalUsd">¡Hacelos crecer!</p>
          <img src="/assets/icons/arrow-down.svg" /> -->
        </div>
        <div class="balance-header">
          <img src="/assets/icons/balance-usd.svg" alt="crypto_icon" />
          <h3 class="balance-title">
            {{
              austProfits?.totalUsd
                ? (authService.loggedUser?.balance?.fiat.USD || 0 | currency : 'U$D')
                : 'Dólares'
            }}
          </h3>
        </div>
        <div class="balance-info fiat">
          <h3 class="balance-value">
            {{
              austProfits?.totalUsd
                ? (austProfits?.totalUsd | currency : 'U$D')
                : (balanceUsd || 0 | currency : 'U$D')
            }}
            <span class="label-investment" *ngIf="austProfits?.totalUsd">- invertidos aUST</span>
          </h3>
        </div>
        <img
          class="card-background disappear-mobile disappear-medium-desktop"
          src="/assets/images/balance-usd.svg"
          alt="balance-usd"
        />
      </div>

      <div class="balance fiat-balance ars" (click)="openFiatInvestmentPopup('AR$')">
        <div class="btn-investment">
          <!-- <p [class.invested]="austProfits?.totalArs">¡Hacelos crecer!</p>
          <img src="assets/icons/arrow-down.svg" /> -->
        </div>
        <div class="balance-header">
          <img src="/assets/icons/balance-ars.svg" alt="crypto_icon" />
          <p class="balance-title">
            {{
              austProfits?.totalArs
                ? (authService.loggedUser?.balance?.fiat.ARS || 0 | currency : 'AR$')
                : 'Pesos'
            }}
          </p>
        </div>
        <div class="balance-info fiat">
          <p class="balance-value">
            {{
              austProfits?.totalArs
                ? (austProfits?.totalArs | currency : 'AR$')
                : (authService.loggedUser?.balance?.fiat.ARS || 0 | currency : 'AR$')
            }}
            <span class="label-investment" *ngIf="austProfits?.totalArs">- invertidos aUST</span>
            <!-- {{ authService.loggedUser?.balance?.fiat.ARS || 0 | currency: 'AR$' }} -->
          </p>
        </div>
        <img
          class="card-background disappear-mobile disappear-medium-desktop"
          src="/assets/images/balance-ars.svg"
          alt="balance-ars"
        />
      </div>
    </div>
  </div>
  <div
    class="blur-background"
    (click)="onCloseModal()"
    [class.hide]="!fiatInvestmentPopupIsOpened"
  ></div>
</div>
<app-fiat-investment-popup
  *ngIf="fiatInvestmentPopupIsOpened"
  [selectedCoin]="selectedCoin"
  [austProfit]="austProfits"
  (closeEvent)="onCloseModal()"
></app-fiat-investment-popup>
